module.exports = __webpack_public_path__ + "static/awardsgroup-17cb0a81a5c13ce258c5755fd8ae5049.png";